var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraftsmanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.089,
    height: 58.688,
    fill: "#e9f2f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -5305.97)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(78 5305.97)",
    fill: "#963839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.909 5372.941)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.359,4.364A.963.963,0,0,0,91.606,4H81.994L78.144.272a.965.965,0,0,0-1.343,0L72.951,4H29.477a.949.949,0,0,0-.192.03.794.794,0,0,0-.111.018c-.02.007-.038.021-.057.029a.95.95,0,0,0-.215.113l-.009.005L1.651,24.762A.965.965,0,0,0,2.233,26.5H6.028V51.641H.965A.965.965,0,0,0,0,52.607v5.115a.966.966,0,0,0,.965.966h104.91a.965.965,0,0,0,.965-.966V52.607a.965.965,0,0,0-.965-.966h-1.731V26.5h3.98a.966.966,0,0,0,.659-1.672ZM77.473,2.309,84.29,8.916H70.654ZM57.681,51.641V48.886H97.454v2.756Zm-4.76,0V26.5h2.83V51.641Zm16.093-4.686H62.724v-14.8h6.289Zm28.44,0H70.944V31.193a.966.966,0,0,0-.965-.966h-8.22a.966.966,0,0,0-.965.966V46.955H57.681V26.5H97.454ZM29.475,6.178l24.36,18.39H5.114ZM7.958,26.5H50.991V51.641H7.958ZM104.91,56.757H1.93V53.572H104.91Zm-2.7-5.116h-2.83V26.5h2.83Zm.965-27.073H57.04l-18.815-14.2-5.869-4.43h38.6L67.6,9.188l0,.005a.944.944,0,0,0-.153.2c-.01.017-.02.035-.028.052a.937.937,0,0,0-.086.233v0a.985.985,0,0,0-.021.2v9.581a.965.965,0,1,0,1.93,0V10.847H85.708v8.616a.965.965,0,0,0,1.931,0V10.011a1.047,1.047,0,0,0,.013-.129.967.967,0,0,0-.395-.779L83.987,5.933h7.157L106.1,24.568Z",
    transform: "translate(0 0)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.238,21.508H126.46a.965.965,0,0,0-.965.965v8.294a.965.965,0,0,0,.965.965h7.778a.965.965,0,0,0,.965-.965V22.473a.965.965,0,0,0-.965-.965m-6.813,1.93h1.958V29.8h-1.958Zm5.847,6.363h-1.958V23.438h1.958Z",
    transform: "translate(-52.876 -9.062)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.445,62.531h17.549a.965.965,0,0,0,.965-.965V53.2a.966.966,0,0,0-.965-.966H129.445a.966.966,0,0,0-.965.966v8.363a.965.965,0,0,0,.965.965m16.584-1.93h-6.844V54.168h6.844Zm-15.618-6.433h6.843V60.6h-6.843Z",
    transform: "translate(-54.134 -22.01)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.218,49.193H24.906a.965.965,0,0,0-.965.965V66.19a.965.965,0,0,0,.965.965H54.218a.965.965,0,0,0,.965-.965V50.158a.965.965,0,0,0-.965-.965m-.965,5.588H46.978V51.125h6.274ZM34.077,51.124h10.97v3.657H34.077Zm10.97,14.1H34.077V56.712h10.97Zm-12.9-10.444H25.871V51.125h6.274Zm-6.274,1.931h6.274v8.513H25.871Zm21.106,0h6.274v8.513H46.977Z",
    transform: "translate(-10.087 -20.727)",
    fill: "#e9f2f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftsmanIcon);
export default __webpack_public_path__ + "static/media/CraftsmanIcon.11e99854b3303b248e42e91a546d262c.svg";
export { ForwardRef as ReactComponent };